import axios from 'axios';
import getConfig from '../config';

const { backendApi } = getConfig();

export function maintenanceMode() {
  return axios({
    method: 'GET',
    url: `${backendApi}/api/dashboard/maintenance`,
  })
    .then((res) => res.data?.maintenance)
    .catch((err) => err.response.data);
}
